import { Box, BoxProps, styled, css, Typography } from "@mui/material";
import { rem } from "polished";
import React, { ReactNode } from "react";

type Props = {
  icon?: ReactNode;
  title: string;
  rightNode?: ReactNode;
  disableBackground?: boolean;
  // @note: use for accessibility
  titleVariant?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  titleId?: string;
} & BoxProps;

export const StyledBox = styled(Box)`
  background: ${(props) => props.theme.palette.common.white};

  ${(props) => props.theme.breakpoints.down("sm")} {
    background-color: unset;
    width: 100vw;
  }
`;

export const StyledHeader = styled("div")`
  display: flex;
  justify-content: space-between;
  height: ${rem(80)};
  background: ${(props) => props.theme.palette.common.white};
  align-items: center;
  color: ${(props) => props.theme.palette.green.main};
  border-bottom: ${rem(1)} solid ${(props) => props.theme.palette.gray.background};

  ${(props) => props.theme.breakpoints.down("sm")} {
    height: auto;
    flex-direction: column;
    align-items: flex-start;
  }
`;

export const StyledTitleContainer = styled("div")`
  display: flex;
  align-items: center;
  ${(props) => props.theme.breakpoints.down("sm")} {
    width: 100%;
    justify-content: space-between;
    padding: ${(props) => props.theme.spacing(2)};
  }
`;

export const StyledRightNodeContainer = styled("div")`
  ${(props) => props.theme.breakpoints.down("sm")} {
    width: 100%;
    margin-top: ${(props) => props.theme.spacing(2)};
  }
`;

export const StyledContent = styled("div")<{ $disableBackground: boolean }>`
  ${(props) =>
    props.$disableBackground === false
      ? css`
          background: ${props.theme.palette.common.white};
        `
      : ""};

  ${(props) => props.theme.breakpoints.down("sm")} {
    margin: 0 ${(props) => props.theme.spacing(0)};
  }
`;

export const StyledTitle = styled(Typography)`
  flex: 1;
  font-size: ${rem(20)};
  font-weight: 500;
  color: ${(props) => props.theme.palette.secondary.main};
  margin: 0 ${(props) => props.theme.spacing(2)};

  ${(props) => props.theme.breakpoints.down("sm")} {
    font-size: ${rem(16)};
  }
`;

export const Section = ({
  icon,
  title,
  rightNode,
  children,
  disableBackground = false,
  titleId,
  titleVariant = "h2",
  ...boxProps
}: Props) => {
  return (
    <StyledBox {...boxProps}>
      <StyledHeader>
        <StyledTitleContainer>
          {icon && <>{icon}</>}
          <StyledTitle variant={titleVariant} id={titleId}>
            {title}
          </StyledTitle>
        </StyledTitleContainer>
        {rightNode && <StyledRightNodeContainer>{rightNode}</StyledRightNodeContainer>}
      </StyledHeader>
      <StyledContent $disableBackground={disableBackground}>{children}</StyledContent>
    </StyledBox>
  );
};
